/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

import { Breadcrumbs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useContainer } from 'unstated-next';

import AskTheAIContainer from './AskTheAIContainer';

export const AskTheAIDetail = () => {
    console.log('AskTheAIDetail');
    const { t } = useTranslation(['portal', 'create_edit_class']);
    const { askTheAIData } = useContainer(AskTheAIContainer);
    console.log(askTheAIData);
    return (
        <>
            <Breadcrumbs aria-label="breadcrumb">
                <Link to="/portal/askTheAI">{t('portal:askTheAI')}</Link>
            </Breadcrumbs>
            <div style={{ textAlign: 'center' }}>
                <h2 style={{ textAlign: 'center' }}>{t('coming-soon-1')}</h2>
                <div style={{ fontSize: '16px', marginBottom: '10px' }}>{t('coming-soon-2')}</div>
            </div>
        </>
    );
};
